module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performances/performances-index/performances-index.component.scss
// module id = ./src/app/routes/performances/performances-index/performances-index.component.scss
// module chunks = 9